import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';

import { formatLargeNumber } from '../../service/market';

import Header from '../../containers/instrument/Header';
import ChangeComponent from './ChangeComponent';
import CurrencyCalculator from '../../containers/instrument/CurrencyCalculator';

import instrument from '../../styles/instrument/instrument';
import css from '../../styles/instrument/cryptocurrency';
import summary from '../../styles/instrument/summary';

class CryptocurrencyInstrument extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        symbol: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,

        LONG_NAME: PropTypes.string.isRequired,
        SHORT_NAME: PropTypes.string.isRequired,
        LAST: PropTypes.number.isRequired,
        CHANGE: PropTypes.number.isRequired,
        CHANGE_PCT: PropTypes.number.isRequired,
        CHANGE_1H_PCT: PropTypes.number.isRequired,
        CHANGE_7DAYS_PCT: PropTypes.number.isRequired,
        VOLUME_24H: PropTypes.number.isRequired,
        MARKET_CAP: PropTypes.number.isRequired,
        AVAILABLE_SUPPLY: PropTypes.number.isRequired,
        TOTAL_SUPPLY: PropTypes.number.isRequired,
        CURRENCY: PropTypes.string.isRequired,
        last_updated: PropTypes.number.isRequired,

        breakpoint: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this._renderTime = prop => {
            const dateFormat = moment((this.props[prop]))
                .isSame(moment().startOf('day'), 'd')
                ? 'HH:mm:ss' : 'DD. MMM';

            return moment(this.props[prop]).format(dateFormat);
        };
    }

    /* @TODO Add this if MAX_SUPPLY is added to API at some point. request has been sent
    /* renderPieChart() {
        const { AVAILABLE_SUPPLY, TOTAL_SUPPLY, SHORT_NAME } = this.props;
        const data = [];

        data.push({
            name: 'Sirkulerende',
            y: (AVAILABLE_SUPPLY),
            selected: false,
            color: '#48A2D3',
        });

        data.push({
            name: 'Ikke i omløp',
            y: (TOTAL_SUPPLY - AVAILABLE_SUPPLY),
            selected: false,
            color: '#DCD5CD',
        });

        const config = Object.assign({}, defaultOptions, {
            tooltip: {
                headerFormat: [
                    '<span style="font-size: 10px">',
                    '{point.key} ({point.percentage:.1f} %)',
                    '</span><br/>',
                ].join(''),
                pointFormatter: function () {
                    return [formatLargeNumber(this.y), SHORT_NAME].join(' ');
                },
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: { enabled: false },
                },
            },
            series: [{ data }],
        });

        return (
            <div>
                <HeaderComponent title="Kapasitet" />
                <HighchartsPie
                    config={config}
                    data={data}
                    ref={(node) => { if (node) this.chart = node; }}
                    className={css.graph}
                />
                <div className={css.capacitySummary}>
                    {formatLargeNumber(AVAILABLE_SUPPLY)} av {formatLargeNumber(TOTAL_SUPPLY)}
                </div>
            </div>
        );
    } */

    renderSummary() {
        const { t, VOLUME_24H, SHORT_NAME } = this.props;

        return (
            <div className={summary.container}>
                <div className={summary.list}>
                    <div className={summary.entry}>
                        <span className={summary.heading}>{t('updated')}</span>
                        <span>{this._renderTime('last_updated')}</span>
                    </div>
                    <div className={summary.entry}>
                        <span className={summary.heading}>{t('currencyCode')}</span>
                        <span>{SHORT_NAME}</span>
                    </div>
                    <div className={summary.entry}>
                        <span className={summary.heading}>{t('volume24h')}</span>
                        <span>{formatLargeNumber(VOLUME_24H)}</span>
                    </div>
                </div>
            </div>
        );
    }

    renderChange() {
        const { t, CHANGE_PCT, CHANGE_1H_PCT, CHANGE_7DAYS_PCT } = this.props;

        const result = [];
        result.push(
            <ChangeComponent
                key={['1h', CHANGE_1H_PCT].join('')}
                title={t('date:hour', { count: 1 })}
                change={CHANGE_1H_PCT}
                titleIsTime
            />
        );
        result.push(
            <ChangeComponent
                key={['24h', CHANGE_PCT].join('')}
                title={t('date:hour', { count: 24 })}
                change={CHANGE_PCT}
                titleIsTime
            />
        );
        result.push(
            <ChangeComponent
                key={['7d', CHANGE_7DAYS_PCT].join('')}
                title={t('date:weekWithCount', { count: 1 })}
                change={CHANGE_7DAYS_PCT}
                titleIsTime
            />
        );

        return result;
    }

    render() {
        const { symbol, title, breakpoint } = this.props;

        return (
            <div className={instrument.container}>
                <Header
                    symbol={symbol}
                    title={title}
                    breakpoint={breakpoint === 'mobile-small'}
                    noGraph
                />
                <div className={css.changeContainer}>
                    {this.renderChange()}
                </div>
                {this.renderSummary()}
                <CurrencyCalculator symbol={symbol} defaultValue={1} instrument />
            </div>
        );
    }
}

export default translate('cryptoCurrencies')(CryptocurrencyInstrument);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/CryptocurrencyInstrument.js
 **/